<template>
  <div class="container">
    <headerNavbar title="团队体检预约"></headerNavbar>
    <div v-if="!orderList.length && !isLoading">
      <van-empty image="search" description="未找到单位预约信息" />
    </div>
    <div v-else>
      <div v-for="(order,i) in orderList" class="order-card">
        <div class="order-header">
          <div class="order-header-left">
            <h3>{{order.companyName}} </h3>
          </div>
          <div class="order-header-right">
            <span class="order-status" v-if="order.appointStatus==0">未预约</span>
            <span class="order-status--examed" v-else-if="order.appointStatus==1">已预约</span>
            <span class="order-status--examed" v-else-if="order.appointStatus==2">已体检</span>
          </div>
        </div>
        <div class="order-content">
          <div class="order-content-item">
            <span class="order-content-item-text">单位批次</span>
            <span class="order-content-item-value">{{order.companyBatchName}}</span>
          </div>
          <div class="order-content-item">
            <span class="order-content-item-text">员工姓名</span>
            <span class="order-content-item-value">{{order.name}}</span>
          </div>
          <div class="order-content-item">
            <span class="order-content-item-text">体检套餐</span>
            <span class="order-content-item-value">{{order.groupName}}</span>
          </div>
          <div class="order-content-item" v-if="order.appointStatus!=0">
            <span class="order-content-item-text">体检日期</span>
            <span class="order-content-item-value">{{order.appointDate}} {{order.appointTimeRangeName}}</span>
          </div>
        </div>
        <div class="order-footer">
          <!-- <van-button type="info" plain size="small" round @click="detail()" style="margin-right:16px;">查看详情
        </van-button> -->
          <van-button type="info" plain size="small" round @click="detail(order)" v-if="order.appointStatus==0">预约体检
          </van-button>
          <van-button plain size="small" round @click="info(order)" v-if="order.appointStatus==1"
            style="margin-right:16px">
            查看详情
          </van-button>
          <van-button type="danger" plain size="small" round @click="cancel(order)" v-if="order.appointStatus==1">
            取消预约
          </van-button>
        </div>
      </div>
    </div>

    <!-- 测试功能 -->
    <div v-if="false">
      <!-- 一年内的订单数据 -->
      <div v-if="recentOrderList.length">
        <div v-for="(order,i) in recentOrderList" class="order-card">
          <div class="order-header">
            <div class="order-header-left">
              <h3>{{order.companyName}} </h3>
            </div>
            <div class="order-header-right">
              <span class="order-status" v-if="order.appointStatus==0">未预约</span>
              <span class="order-status--examed" v-else-if="order.appointStatus==1">已预约</span>
              <span class="order-status--examed" v-else-if="order.appointStatus==2">已体检</span>
            </div>
          </div>
          <div class="order-content">
            <div class="order-content-item">
              <span class="order-content-item-text">单位批次</span>
              <span class="order-content-item-value">{{order.companyBatchName}}</span>
            </div>
            <div class="order-content-item">
              <span class="order-content-item-text">员工姓名</span>
              <span class="order-content-item-value">{{order.name}}</span>
            </div>
            <div class="order-content-item">
              <span class="order-content-item-text">体检套餐</span>
              <span class="order-content-item-value">{{order.groupName}}</span>
            </div>
            <div class="order-content-item" v-if="order.appointStatus!=0">
              <span class="order-content-item-text">体检日期</span>
              <span class="order-content-item-value">{{order.appointDate}} {{order.appointTimeRangeName}}</span>
            </div>
          </div>
          <div class="order-footer">
            <van-button type="info" plain size="small" round @click="detail(order)" v-if="order.appointStatus==0">预约体检
            </van-button>
            <van-button plain size="small" round @click="info(order)" v-if="order.appointStatus==1"
              style="margin-right:16px">
              查看详情
            </van-button>
            <van-button type="danger" plain size="small" round @click="cancel(order)" v-if="order.appointStatus==1">
              取消预约
            </van-button>
          </div>
        </div>
      </div>
      <div v-else-if="showHistoryOrder==false">
        <van-empty image="search" description="未找到一年内的单位预约信息" />
      </div>
      <div class="showMoreButton" v-if="historyOrderList.length && showHistoryOrder==false">
        <van-button round type="default" size="mini" @click="showHistoryOrder = true">显示更早的数据</van-button>
      </div>
      <!-- 一年前的订单数据 -->
      <div v-if="showHistoryOrder">
        <div v-for="(order,i) in historyOrderList" class="order-card">
          <div class="order-header">
            <div class="order-header-left">
              <h3>{{order.companyName}} </h3>
              <!-- <p class="team-title">2020年度体检</p> -->
            </div>
            <div class="order-header-right">
              <span class="order-status" v-if="order.appointStatus==0">未预约</span>
              <span class="order-status--examed" v-else-if="order.appointStatus==1">已预约</span>
              <span class="order-status--examed" v-else-if="order.appointStatus==2">已体检</span>
            </div>
          </div>
          <div class="order-content">
            <div class="order-content-item">
              <span class="order-content-item-text">单位批次</span>
              <span class="order-content-item-value">{{order.companyBatchName}}</span>
            </div>
            <div class="order-content-item">
              <span class="order-content-item-text">员工姓名</span>
              <span class="order-content-item-value">{{order.name}}</span>
            </div>
            <div class="order-content-item">
              <span class="order-content-item-text">体检套餐</span>
              <span class="order-content-item-value">{{order.groupName}}</span>
            </div>
            <div class="order-content-item" v-if="order.appointStatus!=0">
              <span class="order-content-item-text">体检日期</span>
              <span class="order-content-item-value">{{order.appointDate}} {{order.appointTimeRangeName}}</span>
            </div>
          </div>
          <div class="order-footer">
            <!-- <van-button type="info" plain size="small" round @click="detail()" style="margin-right:16px;">查看详情
        </van-button> -->
            <van-button type="info" plain size="small" round @click="detail(order)" v-if="order.appointStatus==0">预约体检
            </van-button>
            <van-button plain size="small" round @click="info(order)" v-if="order.appointStatus==1"
              style="margin-right:16px">
              查看详情
            </van-button>
            <van-button type="danger" plain size="small" round @click="cancel(order)" v-if="order.appointStatus==1">
              取消预约
            </van-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹框文本内容 -->
    <van-dialog v-model="showNoticeDialog" title="团检预约提示" @close="onNoticeDialogClose">
      <p class="notice-text">
        {{currAppointment.batchNoticeContent}}
      </p>
    </van-dialog>

    <!-- 弹框文本内容 -->
    <van-dialog v-model="showMaritalDialog" title="选择您的婚姻状态后继续" @close="saveMarital()">
      <div class="marital-options">
        <van-radio-group v-model="userProfile.marital">
          <van-radio :name="0">未婚</van-radio>
          <van-radio :name="1">已婚</van-radio>
          <van-radio :name="2">其它</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>
  </div>
</template>

<style lang="less" scoped>
  .container {
    padding: 0 12px;
    color: rgba(0, 0, 0, 0.75);
  }

  .showMoreButton {
    text-align: center;
    margin: 16px 0;
  }

  .order-card {
    border-radius: 8px;
    background: #fff;
    margin-top: 16px;
    padding: 16px;

    .order-header {
      display: flex;
      // border-bottom: 1px solid #ebedf0;
      margin-bottom: 8px;

      .order-header-left {
        flex: 1;

        h3 {
          font-size: 16px;
          font-weight: 600;
        }

        .team-title {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
        }
      }

      .order-header-right {
        font-size: 14px;
        margin: auto 0;

        .order-status {
          color: @orange;
        }

        .order-status--booked {
          color: @blue;
        }

        .order-status--examed {
          color: @gray-7;
        }
      }
    }

    .order-content {
      font-size: 14px;
      line-height: 36px;

      .order-content-item-text {
        margin-right: 24px;
        color: rgba(0, 0, 0, 0.45);
        // color: rgba(0, 0, 0, 0.45);
      }

      .order-content-item-value {
        color: rgba(0, 0, 0, 0.8);
      }
    }

    .order-footer {
      padding-top: 8px;
      border-top: 1px solid #ebedf0;
      text-align: right;
    }
  }

  .notice-text {
    padding: 12px;
    font-size: 15px;
    line-height: 28px;
    white-space: pre-wrap;
  }

  .marital-options {
    padding: 16px 32px;
  }

  /deep/.van-dialog {
    width: 360px;
  }

  /deep/.van-radio {
    margin: 16px;
  }
</style>

<script>
  import {
    getOrderList,
    getAppointments,
    cancelAppointment,
    getGroupDetails,
  } from '@/api/company'
  import {
    getConfigs
  } from '@/api/hospital';
  import * as lib_auth from "@/libs/auth";
  import {
    getUserProfiles,
    updateProfile
  } from "@/api/user";
  import headerNavbar from '../components/headerNavbar'
  import moment from 'moment';

  export default {
    components: {
      headerNavbar
    },
    data() {
      return {
        orderList: [],
        recentOrderList: [], //最近的（创建时间一年内）订单
        historyOrderList: [], //历史订单数据(早于一年前)
        showHistoryOrder: false, //是否显示历史订单数据
        userProfile: {},
        showNoticeDialog: false,
        showMaritalDialog: false,
        currAppointment: {},
        showTop1CompanyAppointment: false, //是否仅显示最近一条单位预约记录,
        isLoading: false,
      }
    },
    async mounted() {
      this.isLoading = true;
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '正在查询',
      });
      //获取界面配置 ,是否仅显示最近一条单位预约记录
      getConfigs(this.$route.query.hospid).then(res => {
        let configs = res.data;
        let config = configs.find(it => {
          return it.code === 'show_top1_company_appointment'
        });
        this.showTop1CompanyAppointment = config && config.value == "是";
      })
      // 获取单位预约数据
      let profiles = await getUserProfiles();
      if (profiles.code != 200 || profiles.data.length == 0) {
        this.$toast.clear();
        this.$toast.fail("查询单位预约失败");
        this.isLoading = false;
        return;
      } else {
        this.userProfile = profiles.data[0]; //to do
        this.getList();
        this.$toast.clear();
        this.isLoading = false;
      }
    },
    methods: {
      getList() {
        let hospid = this.$route.query.hospid;
        getAppointments(hospid).then(resp => {
          var orders = resp.data.sort((a, b) => {
            return b.examNo.localeCompare(a.tjbh)
          });
          this.orderList = [];
          this.recentOrderList = [];
          this.historyOrderList = [];
          if (orders && orders.length) {
            if (this.showTop1CompanyAppointment) {
              this.orderList.push(orders[0]);
            } else {
              this.orderList = orders;
            }
          }
          for (let index = 0; index < orders.length; index++) {
            const order = orders[index];
            const yearsDiff = moment().diff(moment(order.createTime), 'years');
            if (yearsDiff > 0) {
              this.recentOrderList.push(order);
            } else {
              this.historyOrderList.push(order);
            }
          }
        });
      },
      detail(order) {
        this.currAppointment = order;
        this.handleOrder();
      },
      handleOrder() {
        if (!this.currAppointment || !this.userProfile) {
          return;
        }
        if (this.userProfile.marital == null) {
          this.showMaritalDialog = true;
          return;
        }
        if (this.currAppointment.batchNoticeContent && this.currAppointment.batchNoticeContent.length) {
          this.showNoticeDialog = true;
          return;
        }
        localStorage.setItem("companyAppointment", JSON.stringify(this.currAppointment))
        this.orderPortal();
      },
      info(order) {
        localStorage.setItem("companyAppointment", JSON.stringify(order))
        this.$router.push({
          path: "/company/orderInfo"
        });
      },
      //根据加项配置参数跳转到不同页面
      orderPortal() {
        getGroupDetails(this.currAppointment.groupId).then(res => {
          if (res.data == null || res.data.addinMode == 0) {
            this.$router.push({
              path: "/company/orderDetail"
            });
          } else if (res.data.addinMode == 1) {
            this.$router.push({
              name: "companyOrderAddItem"
            });
          } else if (res.data.addinMode == 2) {
            this.$router.push({
              name: "companyOrderAddCombo"
              //name: "companyGroupSelect"
            });
          } else if (res.data.addinMode == 3 && res.data.name == '员工自选') {
            this.$router.push({
              name: "companyGroupSelect"
            });
          } else {
            this.$router.push({
              path: "/company/orderDetail"
            });
          }
        })
      },
      //关闭弹框时的回调方法
      onNoticeDialogClose() {
        localStorage.setItem("companyAppointment", JSON.stringify(this.currAppointment))
        this.orderPortal();
      },
      saveMarital() {
        let _this = this;
        _this.showMaritalDialog = false;
        updateProfile(this.userProfile).then(res => {
          _this.handleOrder();
        })
      },
      cancel(order) {
        this.$Dialog.confirm({
            message: '是否取消预约？',
            "cancelButtonText": "我再想想",
            "confirmButtonText": "取消预约",
          })
          .then(() => {
            // on confirm
            cancelAppointment(order).then(res => {
              console.log(res);
              if (res.code == 200) {
                this.$toast.success(res.msg);
              }
              this.getList();
            })
          })
          .catch(() => {
            // on cancel
          });

      }
    },
  }
</script>